import { makeStyles } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useGetMaintenanceModeQuery } from "../../repositories/queries/maintenance/get-maintenance-mode.query";

const useStyles = makeStyles({
  alert: {
    marginBottom: 16,
  },
  title: {
    fontSize: "1.1rem",
    fontWeight: 700,
  },
});

export const MaintenanceModeNotice: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { data: maintenanceMode } = useGetMaintenanceModeQuery();

  if (!maintenanceMode?.active) {
    return null;
  }

  return (
    <Alert severity="warning" className={classes.alert} id="maintenanceModeNotice">
      <AlertTitle className={classes.title}>{t("maintainance.title")}</AlertTitle>
      {maintenanceMode.description
        ? t("maintainance.login_notice_until", { description: maintenanceMode.description })
        : t("maintainance.login_notice")}
    </Alert>
  );
};
